import React from "react";
import "./ProgressBar.scss";

const ProgressBar = ({ progress = 0, color = "#CA8504", height = "6px" }) => {
  const safeProgress = Math.min(Math.max(progress, 0), 100); // Clamp 0–100
  const displayProgress = safeProgress === 0 ? 2 : safeProgress; // visible sliver when 0%

  return (
    <div className="progress-bar">
      <div className="progress-bar__header">
        <div className="progress-bar__header-left">Progress</div>
        <div className="progress-bar__header-right">{safeProgress}%</div>
      </div>
      <div className="progress-bar__track" style={{ height }}>
        <div
          className={`progress-bar__fill ${safeProgress === 0 ? "zero" : ""}`}
          style={{
            width: `${displayProgress}%`,
            backgroundColor: color,
          }}
        ></div>
      </div>
    </div>
  );
};

export default ProgressBar;
